import React from "react";
import { h, Component } from "preact";

export default class MenuItem extends Component {
    render() {
        const item = this.props.item;
        const sendMessage = this.props.sendMessage;
        const onClick = this.props.onClick;

        const Tag = item.type === "url" ? "a" : "div";
        const icon = item.icon;

        const iconNamespace = icon ? icon.namespace : "fa";
        const iconName = icon ? icon.icon : "external-link-alt";

        return (
            <li
                onClick={() => {
                    onClick();
                    if (item.type === "trigger") {
                        sendMessage(item.title, null, item.value, item.value);
                    }
                }}>
                <Tag target={"_blank"} href={item.href}>
                    <i className={`${iconNamespace} fa-${iconName}`} />
                    {item.title}
                </Tag>
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/widget/MenuItem.js